export enum FilterType {
  name = 'nome',
  role = 'cargo',
  department = 'departamento',
  team = 'time',
  branch = 'filial'
}
